import * as TYPES from './constants';
import {API} from 'config/employer.config';
import {JWT_HEADER, JSON_HEADER} from 'config/srm.config';
import {
  resolveRopInstitutionUuidList,
  appendRecruitmentInstitutionUuidListParams,
} from 'utils/employerTalentRop';
import {
  requestGoSurveyResults,
  receiveGoSurveyResults,
  handleGoSurveyResultsError,
} from './actions';

const initialState = {
  data: null,
  error: false,
  request: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.GO_SURVEY_RESULTS_REQUEST:
      return {
        ...state,
        request: true,
      };
    case TYPES.GO_SURVEY_RESULTS_RECEIVE:
      return {
        ...state,
        request: false,
        data: action.payload,
      };
    case TYPES.GO_SURVEY_RESULTS_ERROR:
      return {
        ...state,
        error: true,
        request: false,
      };
    case TYPES.CLEAR_GO_SURVEY_RESULTS:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export const fetchGoSurveyResults = (careerArea, params) => (
  dispatch,
  getState
) => {
  const {
    auth: {
      access: {token},
    },
  } = getState();
  const config = {
    mode: 'cors',
    method: 'GET',
    cache: 'default',
    headers: Object.assign({}, JWT_HEADER(token), JSON_HEADER),
  };
  dispatch(requestGoSurveyResults());
  const {page = 1, sort = 'date_desc', pageSize = 50, filters = []} =
    params || {};
  let URI = `${
    API.administration.gosurvey_results
  }&page=${page}&page_size=${pageSize}&sort=${sort}&career_area=${careerArea}`;

  if (filters && filters.length > 0) {
    filters.forEach(filter => {
      URI += `&${filter.key}=${filter.value}`;
    });
  }
  try {
    return resolveRopInstitutionUuidList(dispatch, getState, token)
      .then(ropList =>
        fetch(appendRecruitmentInstitutionUuidListParams(URI, ropList), config)
      )
      .then(response => response.json())
      .then(json => {
        dispatch(receiveGoSurveyResults(json));
      })
      .catch(err => {
        console.log(err);
        dispatch(handleGoSurveyResultsError(err));
      });
  } catch (err) {
    console.log(err);
    dispatch(handleGoSurveyResultsError(err));
  }
};
